var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlatPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.719,
    height: 17.751,
    viewBox: "0 0 17.719 17.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.061 -0.015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.182,9.875,7.938.612A2.149,2.149,0,0,0,4.9.68l-.1.1L4.761.74A2.492,2.492,0,0,0,1.238.829l-.283.284A2.5,2.5,0,0,0,.869,4.639l.039.039-.183.184A2.156,2.156,0,0,0,.658,7.906L9.9,17.168a2.149,2.149,0,0,0,3.04-.067l4.175-4.182a2.156,2.156,0,0,0,.066-3.045ZM3.839,5.741A1.783,1.783,0,0,1,2.1,3.92,1.782,1.782,0,0,1,3.839,2.1,1.783,1.783,0,0,1,5.578,3.92,1.784,1.784,0,0,1,3.839,5.741Zm9.985,8.774-1.2-1.2a2.7,2.7,0,0,1-2.423.4.7.7,0,0,1-.414-.369.728.728,0,0,1-.022-.572.758.758,0,0,1,.949-.455,1.147,1.147,0,0,0,.844-.075l-1.39-1.4a2.574,2.574,0,0,1-3.319-.121A2.562,2.562,0,0,1,6.732,7.4L5.553,6.219l.7-.7L7.437,6.7a2.72,2.72,0,0,1,2.432-.4.721.721,0,0,1,.435.943.765.765,0,0,1-.951.454,1.146,1.146,0,0,0-.841.07l1.4,1.394a2.564,2.564,0,0,1,3.289.142,2.549,2.549,0,0,1,.147,3.278l1.2,1.194-.722.736Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.768,18.386a1.035,1.035,0,0,0,1.2.119l-1.318-1.323a1.039,1.039,0,0,0,.119,1.205Z",
    transform: "translate(-7.834 -8.702)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.392,20.78a1.018,1.018,0,0,0-1.155-.138l1.293,1.289a1.018,1.018,0,0,0-.139-1.152Z",
    transform: "translate(-11.242 -10.399)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatPrice);
export default __webpack_public_path__ + "static/media/FlatPrice.00290a6279d34aaeaad05170f596de02.svg";
export { ForwardRef as ReactComponent };